import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=40bceac6&scoped=true"
import script from "./InputSelect.ts?vue&type=script&lang=ts&external"
export * from "./InputSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./InputSelect.scss?vue&type=style&index=0&id=40bceac6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bceac6",
  null
  
)

export default component.exports